import React, { Component } from 'react';
import {convertOverTime, checkOverTime} from 'js/Core/date';
import {lang} from 'js/Core/lang';
const txtLang = lang.txt;
export const ConfirmationContainer = (confirmProps) => {
    let {selectedProducts, selectedCalendar, selectedTimeline,products, steps, shopName, fieldsDefination, bookerInfo} = confirmProps,
        {customerName, fullName, phoneNumber, email, birthDate,  age, sex, emailSubscribe} = bookerInfo;
    let productName = [];
    selectedProducts.forEach(item => {
        let check = products.find(e => e.id === item);
        if(check){
            productName.push(check);
        }        
    })    
    return (
        <div className={`steps${steps.currentStep === 3 ? ' active' : ''}`}>
            <h3 id="bookerInfoTable" className="cor_ttl">{txtLang.label_header_info}</h3>
            <table className="form">
                <tbody>
                    <FormFieldItem 
                        txtLabel = {txtLang.customer_name}
                        fieldRequired = {fieldsDefination.displayName}
                        value = {customerName}
                    />
                    <FormFieldItem 
                        txtLabel = {txtLang.full_name}
                        fieldRequired = {fieldsDefination.fullName}
                        value = {fullName}
                    />
                    <FormFieldItem 
                        txtLabel = {txtLang.birthDate}
                        fieldRequired = {fieldsDefination.birthDate}
                        fieldDate = {true}
                        value = {birthDate}
                    />
                    <FormFieldItem 
                        txtLabel = {txtLang.phone_number_yuri}
                        fieldRequired = {fieldsDefination.phone}
                        value = {phoneNumber}
                    />
                    <FormFieldItem 
                        txtLabel = {txtLang.email}
                        fieldRequired = {fieldsDefination.email}
                        value = {email}
                    />
                <tr>
                    <th>{lang.label.sex}</th>
                    <td>{sex}</td>
                </tr>
                <tr>
                    <th>{lang.label.age}</th>
                    <td>{age}</td>
                </tr>
                </tbody>
            </table>
            <h3  className="cor_ttl">{txtLang.label_header_menu}</h3>
            <table id='tableScheduleDateTimeLine' className="form">
                <tbody>
                    <tr>
                        <th>{txtLang.label_select_product} <span className="red">{txtLang.label_required}</span></th>
                        <td>
                            {
                                productName.length > 0 ? 
                                <ul className="list-product-selected">{productName.map(e => <li key={e.id}>{e.productName}</li>)}</ul> : ''
                            }
                        </td>
                    </tr>
                    <tr>
                        <th>{txtLang.label_select_timeline} <span className="red">{txtLang.label_required}</span></th>
                        <td>                            
                            <p>
                                {selectedCalendar} ({convertOverTime(selectedTimeline.from)} <span className="char-line">~</span> {convertOverTime(selectedTimeline.to)})</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

const FormFieldItem = ({txtLabel, fieldRequired, value}) => {
    return (
        fieldRequired !== 'HIDDEN' ? 
        <tr>
            <th>{txtLabel} {fieldRequired === 'REQUIRED' ? <span className="red">{txtLang.label_required}</span> : null }</th>
            <td>{value}</td>
        </tr> : null
    )
}